import { linkStyle } from '@mathflat/common/style'
import clsx from 'clsx'
import { observer } from 'mobx-react'
import { useLocalObservable } from 'mobx-react-lite'
import { useRouteMatch } from 'react-router-dom'

import { NavigationLink } from '@/component/atoms/NavigationLink'
import HeaderUtil from '@/component/molecules/HeaderUtil'
import useRepository from '@/hooks/useRepository'
import { LessonGroupService } from '@/page/Lesson/_service'
import commonRepo from '@/repository/common.repo'
import { RouteName } from '@/router'
import { mixpanelClient } from '@/utils/trackings/mixpanel'

import SideNavigationOpenButton from '../Navigation/SideNavigation/SideNavigationOpenButton'
import AccordionOpenButton from '../StudentGroupAccordion/AccordionOpenButton'
import AcademyLogo from './AcademyLogo/AcademyLogo'
import S from './Header.style'

type RouteType = {
  label: React.ReactNode
  to: () => string
  matchUrl: string
  onClick?: () => void
}
const Header = () => {
  const lessonGroupService = useRepository(LessonGroupService)

  const lessonPreparationPathMatch = useRouteMatch(`${RouteName.lessonPreparation}/*`)
  const lessonPathMatch = useRouteMatch(`${RouteName.lesson}/*`)
  const academyPathMatch = useRouteMatch(RouteName.academy)

  const store = useLocalObservable(() => ({
    get route() {
      const routeList: RouteType[] = [
        commonRepo.permission.get.prepare.access && {
          label: '수업 준비',
          to: () =>
            commonRepo.router.getLastLocation(RouteName.lessonPreparation) ||
            RouteName.lessonPreparation,
          matchUrl: RouteName.lessonPreparation,
          onClick: () => mixpanelClient.track('GNB_수업준비탭_Click'),
        },
        commonRepo.permission.get.lesson.access && {
          label: '수업',
          to: lessonGroupService.fallbackPath,
          matchUrl: RouteName.lesson,
          onClick: () => mixpanelClient.track('GNB_수업탭_Click'),
        },
        commonRepo.permission.get.manage.access && {
          label: '관리',
          to: () => commonRepo.router.getLastLocation(RouteName.academy) || RouteName.academy,
          matchUrl: RouteName.academy,
          onClick: () => mixpanelClient.track('GNB_관리탭_Click'),
        },
      ].filter(Boolean) as RouteType[]
      return routeList
    },
  }))

  return (
    <header css={S.header}>
      <div className="header-container">
        <div className={clsx('header-container-left')}>
          {lessonPathMatch?.isExact && <AccordionOpenButton routeKey={RouteName.lesson} />}
          {/* {lessonPreparationPathMatch?.isExact && <SideNavigationOpenButton />} */}
          {academyPathMatch && <SideNavigationOpenButton />}
          <AcademyLogo routeKey={RouteName.lesson} />
          <nav
            className={clsx(
              'nav-link',
              store.route.find((a) => a.label === '수업') && 'nav-link__lesson',
            )}
          >
            {store.route.map((route) => {
              return (
                route && (
                  <NavigationLink
                    key={route.matchUrl}
                    data-mathflat-unique-id={route.matchUrl}
                    defaultStyle={{
                      ...linkStyle,
                    }}
                    to={route.to}
                    matchUrl={route.matchUrl}
                    onClick={route.onClick}
                  >
                    {route.label}
                  </NavigationLink>
                )
              )
            })}
          </nav>
        </div>
        <div className={clsx('header-container-right')}>
          <HeaderUtil />
        </div>
      </div>
    </header>
  )
}

export default observer(Header)
